<template>
	<el-dialog title="新增线路" :visible.sync="dialogFormVisible" width="800px" :center="true">
        <el-form :model="formNew" ref="formNew" :rules="rules" label-width="110px" class="demo-form-inline" size="small">
          <el-form-item label="所属用户/组织" :label-width="formLabelWidth" prop="parent">
            <el-input v-model="formNew.parent" autocomplete="off" :disabled="true" class="fm2-input-text-wth"></el-input>
          </el-form-item>
          <el-form-item label="线路名称" :label-width="formLabelWidth" prop="road_name">
            <el-input v-model="formNew.road_name" autocomplete="off" placeholder="请输入线路名称" class="fm2-input-text-wth"></el-input>
          </el-form-item>
          <el-form-item label="巡检点" prop="road_line">
        	<el-transfer v-model="transferCard.value" :titles="['待选巡检项', '已选巡检项']" :data="transferCard.data"></el-transfer>
      	  </el-form-item>
          <el-form-item label="备注" :label-width="formLabelWidth" prop="remark">
            <el-input type="textarea" :rows="5" v-model="formNew.remark"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="saveRoadInfo()" size="small">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import Api from '../../api/index'

export default {
  name: "RoadInfoForm",
  data() {
    return {
        dialogFormVisible: false,
        formLabelWidth: '110px',
        displayPassword: true,
        parent_id: 0,
        rules: {
            road_name: [
            { required: true, message: '请输入线路名称', trigger: 'blur' }
          ]
        },
        formNew: {
          road_id: 0,
          parent: "",
          road_name: "",
          remark: ""
        },
        transferCard: {
        	data: [],
        	value: []
        }
    }
  },
  methods: {
    show: function(id, parent_id) {
        this.dialogFormVisible = true;

        // 加载巡检点
        this.delegInitPatrolCardOptions(parent_id);

        if(id > 0) {
          // id > 0时parent_id无参考意义
          this.displayPassword = false;
          Api.GetRoadDetail({ road_id: id }).then(res => {
            if(!res)
              return;

            if(res.code !== 200) {
              this.$message.error(res.msg);
            }

            if(res.data) {
              this.parent_id = res.data.hold_id;
              this.formNew.road_id = res.data.road_id;
              this.formNew.road_name = res.data.road_name;
              this.formNew.remark = res.data.remark;

                if(res.data.patrol_card_ids) {
                    var cs = res.data.patrol_card_ids.split(',');
                    for(var c=0; c<cs.length; c++) {
                        if(!cs[c])
                            continue;
                        this.transferCard.value.push(parseInt(cs[c]));
                    }
                    console.log(`trans cards: ${this.transferCard.value}.`);
                }

              Api.LoadParentBase({ id: this.parent_id }).then(res => {
                if(!res && res.code !== 200)
                  return;

                if(res.data) {
                  this.formNew.hold_id = res.data.hold_id;
                  this.formNew.parent = res.data.hold_name;
                }
              });
            }
          }).catch(err => {
              this.$message.error('错了哦，接口出错！' + err);
          });
        } else {
          this.displayPassword = true;
          this.parent_id = parent_id;

          Api.LoadParentBase({ id: this.parent_id }).then(res => {
            if(!res && res.code !== 200)
              return;

            if(res.data) {
              this.formNew.parent = res.data.hold_name;
            }
          });
        }

    },
    delegInitPatrolCardOptions: function(parentId) {
    		//加载巡检项
        this.transferCard.data = [];
        Api.GetCardOptions({ hold_id: parentId }).then(res => {
        	if(!res && res.code !== 200)
            return;

          for(var i=0; i<res.data.length; i++) {
          	this.transferCard.data.push({
	            label: res.data[i].patrol_name,
	            key: res.data[i].patrol_id,
	            id: res.data[i].patrol_id
	          });
          }

          var id = this.$route.query.id;
          if(id > 0)
          	this.delegInitPatrolDetail(id);
        });
    },
    saveRoadInfo: function() {
      if(this.parent_id < 1) {
        this.$message.error('数据异常，无法保存！');
        return;
      }

      if(this.transferCard.value.length === 0) {
        this.$message.error('请选择巡检点');
        return;
      }

      var card_names = [];
      this.transferCard.data.forEach(x => {
        if(this.transferCard.value.includes(x.id)) {
            card_names.push(x.label);
        }
      });
      
      var argdata = {
        road_id: this.formNew.road_id,
        hold_id: this.parent_id,
        road_name: this.formNew.road_name,
        patrol_card_ids: this.transferCard.value,
        patrol_card_names: card_names,
        remark: this.formNew.remark
      };
      Api.SaveRoadInfoNew(argdata).then(res => {
        if(!res) {
          this.$message.error('出错了！');
          return;
        }

        if(res.code !== 200) {
          this.$message.error(res.msg);
          return;
        }

        console.log(res);

        this.$message({
          message: '恭喜你，提交成功！',
          type: 'success'
        });

        this.$emit("eventRefreshTableName");
        this.dialogFormVisible = false;
      });
    }
  }
}
</script>